import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import { useSettings } from '../context/SettingsContext';
import logger from '../utils/logger';
import env from '../config/env';
import imageCompression from 'browser-image-compression';
import {
  ImagePlus,
  X,
  Edit,
  Save,
  XCircle
} from 'lucide-react';

const EditModal = ({ produkt, onClose, onSave }) => {
  const { settings, getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [previewReja, setPreviewReja] = useState([]);
  const [fotoEkzistuese, setFotoEkzistuese] = useState(produkt.foto || []);
 const [form, setForm] = useState({
  id: produkt.id,
  emri: produkt.emri ?? '',
  emri_mk: produkt.emri_mk ?? '',
  pershkrimi: produkt.pershkrimi ?? '',
  pershkrimi_mk: produkt.pershkrimi_mk ?? '',
  kodi: produkt.kodi ?? '',
  cmimi_blerjes: produkt.cmimi_blerjes != null ? produkt.cmimi_blerjes : '',
  cmimi_shitjes: produkt.cmimi_shitjes != null ? produkt.cmimi_shitjes : '',
  zbritje_perqindje: produkt.zbritje_perqindje != null ? produkt.zbritje_perqindje : '',
  kategoria_id: produkt.kategoria_id != null ? String(produkt.kategoria_id) : '',
  furnizues_id: produkt.furnizues_id != null ? String(produkt.furnizues_id) : '',
  // Sigurohemi që eshte_aktiv është boolean i saktë
  eshte_aktiv: produkt.eshte_aktiv === 1 || produkt.eshte_aktiv === '1' || produkt.eshte_aktiv === true,
  foto: [],
});



  const { data: kategoriteData } = useApi(
    () => apiService.get('/kategorite'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: ngjyratData } = useApi(
    () => apiService.get('/ngjyrat'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: furnizuesitData } = useApi(
    () => apiService.get('/furnizuesit'),
    [],
    { immediate: true, showNotifications: false }
  );

  const kategorite = Array.isArray(kategoriteData) ? kategoriteData : (kategoriteData?.data || []);
  const ngjyrat = Array.isArray(ngjyratData) ? ngjyratData : (ngjyratData?.data || []);
  const furnizuesit = Array.isArray(furnizuesitData) ? furnizuesitData : (furnizuesitData?.data || []);

  // const handleFileChange = async (e) => {
  //   const files = Array.from(e.target.files);
  //   const compressedPhotos = [];
  //   const compressedPreviews = [];

  //   for (const file of files) {
  //     try {
  //       const options = {
  //         maxSizeMB: 0.2,
  //         maxWidthOrHeight: 1280,
  //         useWebWorker: true,
  //       };

  //       const compressedFile = await imageCompression(file, options);

  //       compressedPhotos.push(compressedFile);
  //       compressedPreviews.push({
  //         src: URL.createObjectURL(compressedFile),
  //         file: compressedFile,
  //         name: file.name,
  //         ngjyra_id: ''
  //       });
  //     } catch (error) {
  //       console.error(`❌ Gabim gjatë kompresimit të ${file.name}:`, error);
  //     }
  //   }

  //   setForm(prev => ({
  //     ...prev,
  //     foto: [...prev.foto, ...compressedPhotos.map(file => ({ file, ngjyra_id: '' }))]
  //   }));
  //   setPreviewReja(prev => [...prev, ...compressedPreviews]);
  // };

 const handleFileChange = async (e) => {
  const files = Array.from(e.target.files);
  const compressedPhotos = [];
  const compressedPreviews = [];

  for (const file of files) {
    try {
      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1280,
        useWebWorker: true,
      };

      const compressedBlob = await imageCompression(file, options);

      const mime = compressedBlob.type;
      const ext = mime === 'image/png' ? 'png' : 'jpg';
      const baseName = file.name.split('.').slice(0, -1).join('.') || 'foto';
      const newFileName = `${baseName}_${Date.now()}.${ext}`;

      const compressedFile = new File([compressedBlob], newFileName, {
        type: mime,
        lastModified: Date.now(),
      });

      // Shto për form -> foto
      compressedPhotos.push({
        file: compressedFile,
        ngjyra_id: ''
      });

      // Shto për preview
      compressedPreviews.push({
        src: URL.createObjectURL(compressedFile),
        file: compressedFile,
        name: newFileName,
        ngjyra_id: ''
      });
    } catch (error) {
      console.error(`❌ Gabim gjatë kompresimit të ${file.name}:`, error);
    }
  }

  // Përditëso formën dhe preview
  setForm(prev => ({
    ...prev,
    foto: [...prev.foto, ...compressedPhotos]
  }));
  setPreviewReja(prev => [...prev, ...compressedPreviews]);
};

  
  

  const removePreviewRe = (name) => {
    setPreviewReja(prev => prev.filter(f => f.name !== name));
    setForm(prev => ({
      ...prev,
      foto: prev.foto.filter(f => f.name !== name)
    }));
  };

  const { execute: deleteFoto } = useMutation(
    async (id) => {
      return await apiService.delete(`/produkte/foto/${id}`);
    },
    {
      successMessage: 'Fotoja u fshi me sukses!',
      showNotifications: false
    }
  );

  const removeFotoEkzistuese = async (id) => {
    try {
      await deleteFoto(id);
      setFotoEkzistuese(prev => prev.filter(f => f.id !== id));
    } catch (err) {
      // Error handled by useMutation
    }
  };

  const handleEkzistueseNgjyraChange = (index, value) => {
    const updated = [...fotoEkzistuese];
    updated[index].ngjyra_id = value;
    setFotoEkzistuese(updated);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = value;
    
    // Handle number inputs - convert empty string to empty string (not 0)
    if (type === 'number') {
      processedValue = value === '' ? '' : (value === null || value === undefined ? '' : value);
    }
    
    setForm({ ...form, [name]: type === 'checkbox' ? checked : processedValue });
  };

  const handleSubmit = (e) => {
    if (e?.preventDefault) e.preventDefault();
    
    // Validim i bazë për fushat e detyrueshme
    const validationErrors = [];
    if (!form.emri || String(form.emri).trim() === '') {
      validationErrors.push('Emri i produktit është i detyrueshëm');
    }
    if (!form.kodi || String(form.kodi).trim() === '') {
      validationErrors.push('Kodi i produktit është i detyrueshëm');
    }
    const cmimiBlerjes = form.cmimi_blerjes;
    if (cmimiBlerjes === null || cmimiBlerjes === undefined || cmimiBlerjes === '' || (typeof cmimiBlerjes === 'string' && cmimiBlerjes.trim() === '')) {
      validationErrors.push('Çmimi i blerjes është i detyrueshëm');
    }
    const cmimiShitjes = form.cmimi_shitjes;
    if (cmimiShitjes === null || cmimiShitjes === undefined || cmimiShitjes === '' || (typeof cmimiShitjes === 'string' && cmimiShitjes.trim() === '')) {
      validationErrors.push('Çmimi i shitjes është i detyrueshëm');
    }
    if (!form.kategoria_id || String(form.kategoria_id).trim() === '') {
      validationErrors.push('Kategoria është e detyrueshme');
    }
    
    if (validationErrors.length > 0) {
      alert(validationErrors.join(', '));
      return;
    }
    
    // Call onSave - errors will be handled by the mutation's onError callback
    onSave(form, previewReja, fotoEkzistuese);
  };


  return (
    <div className="fixed inset-0 z-50 bg-black/50 dark:bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
   <div className="card-premium w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6 space-y-6 animate-fadeIn">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-3xl font-bold text-gradient-logo flex items-center gap-3">
            <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
              <Edit size={28} className="text-primary-600 dark:text-primary-400" />
            </div>
            Përditëso Produktin
          </h2>
          <button onClick={onClose} className="text-gray-400 dark:text-gray-500 hover:text-red-600 dark:hover:text-red-400 transition-colors">
                      <XCircle size={26} />
                    </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <input name="emri" value={form.emri} onChange={handleInputChange} placeholder="Emri i produktit" className="input-premium" required />
            <input
  name="emri_mk"
  value={form.emri_mk}
  onChange={handleInputChange}
  placeholder="Emri në maqedonisht"
  className="input-premium"
/>

<textarea
  name="pershkrimi"
  value={form.pershkrimi}
  onChange={handleInputChange}
  placeholder="Përshkrim (shqip)"
  className="input-premium"
/>

<textarea
  name="pershkrimi_mk"
  value={form.pershkrimi_mk}
  onChange={handleInputChange}
  placeholder="Përshkrim (maqedonisht)"
  className="input-premium"
/>

            <input name="kodi" value={form.kodi} onChange={handleInputChange} placeholder="Kodi i produktit" className="input-premium" required />
            <input name="cmimi_blerjes" type="number" value={form.cmimi_blerjes} onChange={handleInputChange} placeholder={`Çmimi Blerjes (${currencyCode})`} className="input-premium" required min="0" step="0.01" />
            <input name="cmimi_shitjes" type="number" value={form.cmimi_shitjes} onChange={handleInputChange} placeholder={`Çmimi Shitjes (${currencyCode})`} className="input-premium" required min="0" step="0.01" />
            <input name="zbritje_perqindje" type="number" value={form.zbritje_perqindje} onChange={handleInputChange} placeholder="Zbritje (%)" className="input-premium" />
            <select name="kategoria_id" value={form.kategoria_id} onChange={handleInputChange} className="input-premium" required>
              <option value="">Zgjidh Kategori</option>
              {kategorite.map(k => (
                <option key={k.id} value={k.id}>{k.emri}</option>
              ))}
            </select>
            {settings && settings.furnizuesit_aktiv !== false && (
              <select name="furnizues_id" value={form.furnizues_id} onChange={handleInputChange} className="input-premium">
                <option value="">Zgjidh Furnizues</option>
                {furnizuesit.map(f => (
                  <option key={f.id} value={f.id}>{f.emri}</option>
                ))}
              </select>
            )}
            <label className="flex items-center gap-2 col-span-full text-gray-700 dark:text-gray-300">
              <input name="eshte_aktiv" type="checkbox" checked={form.eshte_aktiv} onChange={handleInputChange} className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500 dark:focus:ring-primary-400" />
              <span className="text-sm">Produkt Aktiv</span>
            </label>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-gray-800 dark:text-gray-200">Fotot aktuale:</h4>
            <div className="flex flex-wrap gap-2">
              {fotoEkzistuese.map((f, i) => (
               <div key={i} className="relative w-24">
  <img
    src={`${env.API_URL_Image}/storage/${f.file_path}`}
    alt="ekzistuese"
    className="w-full h-20 object-cover rounded border mb-1"
  />
  <select
    className="w-full text-sm border rounded"
    value={f.ngjyra_id || ''}
    onChange={(e) => handleEkzistueseNgjyraChange(i, e.target.value)}
  >
    <option value="">Pa ngjyrë</option>
    {ngjyrat.map(n => (
      <option key={n.id} value={n.id}>{n.emri}</option>
    ))}
  </select>
  <button
    type="button"
    onClick={() => removeFotoEkzistuese(f.id)}
    className="absolute top-0 right-0 bg-red-600 text-white text-xs px-1 rounded-full"
  >
    <X size={12} />
  </button>
</div>

              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-gray-800 dark:text-gray-200">Fotot për shtim:</h4>
            <label className="inline-flex items-center gap-2 bg-primary-100 dark:bg-primary-900/30 hover:bg-primary-200 dark:hover:bg-primary-900/50 text-primary-700 dark:text-primary-300 font-medium px-4 py-2 rounded-xl cursor-pointer shadow-sm transition-colors">
              <ImagePlus size={18} /> Ngarko Foto
              <input type="file" multiple onChange={handleFileChange} className="hidden" />
            </label>
            <div className="flex flex-wrap gap-2 mt-2">
              {previewReja.map((f, i) => (
               <div key={i} className="relative w-24">
  <img src={f.src} alt="preview" className="w-full h-20 object-cover rounded border mb-1" />
  <select
    className="w-full text-sm border rounded"
    value={form.foto[i]?.ngjyra_id || ''}
    onChange={(e) => {
      const updatedFoto = [...form.foto];
      updatedFoto[i].ngjyra_id = e.target.value;
      setForm({ ...form, foto: updatedFoto });

      const updatedPreview = [...previewReja];
      updatedPreview[i].ngjyra_id = e.target.value;
      setPreviewReja(updatedPreview);
    }}
  >
    <option value="">Pa ngjyrë</option>
    {ngjyrat.map(n => (
      <option key={n.id} value={n.id}>{n.emri}</option>
    ))}
  </select>
  <button type="button" onClick={() => removePreviewRe(f.name)} className="absolute top-0 right-0 bg-red-600 text-white text-xs px-1 rounded-full">
    <X size={12} />
  </button>
</div>

              ))}
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="btn-premium-secondary px-4 py-2 flex items-center gap-1">
              <XCircle size={18} /> Anulo
            </button>
            <button type="submit" className="btn-primary px-4 py-2 flex items-center gap-2">
              <Save size={18} /> Ruaj Ndryshimet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;

